module.exports = __webpack_public_path__ + "img/product-sm-3.f0c282cb.png";